import React from 'react';
import { IioSource } from './IioSource';
import type { ForensicImageType } from '../hooks/useIioListing';

interface Props {
  projectId: string;
  forensicImageType: ForensicImageType;
  onChange: (imageType: ForensicImageType) => void;
  selectedPath: string | null;
  onPathChange: (path: string) => void;
  disabled: boolean;
}

const IMAGE_TYPES: { id: ForensicImageType; label: string }[] = [
  { id: 'cellebrite', label: 'Cellebrite' },
  { id: 'oxygen',     label: 'Oxygen' },
  { id: 'axiom',      label: 'Axiom' },
  { id: 'paraben',    label: 'Paraben' },
];

export function ForensicSource({ projectId, forensicImageType, onChange, selectedPath, onPathChange, disabled }: Props) {
  return (
    <div>
      <IioSource
        projectId={projectId}
        selectedPath={selectedPath}
        onPathChange={onPathChange}
        forensicImageType={forensicImageType}
        disabled={disabled}
        title="Forensic Image Listing"
        forensic
      />

      <h4>Forensic Image Type</h4>

      {IMAGE_TYPES.map(t => (
        <div className="radio radio-primary" key={t.id}>
          <input
            id={t.id}
            type="radio"
            name="forensicImageType"
            value={t.id}
            checked={forensicImageType === t.id}
            onChange={() => onChange(t.id)}
            disabled={disabled}
          />
          <label htmlFor={t.id}>
            <span>{t.label}</span>
            {t.id === 'oxygen' && <span> (V.12 and later)</span>}
          </label>
        </div>
      ))}
    </div>
  );
}
